var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-sm pt-2" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-outline-primary btn-block",
        attrs: { type: "button", disabled: _vm.disabledCreateSimilarButton },
        on: { click: _vm.createSimilarPost },
      },
      [_vm._v("\n  " + _vm._s(this.i18n.buttonText) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }